












































helpers = require('../../helpers.coffee')

view_model = {
  data: ->
    business: new Business()
    apiErrorMessages: []
    pristine: true


  methods:
    submit: ->
      @$validator.validateAll().then (success) =>
        @create() if success

    create: ->
      Loader.on()
      @businesses_resource.create @createSuccess, @handleApiErrors, @business
    
    createSuccess: (data) ->
      Loader.off()
      @$emit 'business-create', data.business

  created: ->
    @businesses_resource = new BusinessesResource Session.current_company.id
}

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/businesses/new_modal.vue